import type { FC } from 'react';

import type { AdFields } from '@xing-com/crate-ads-native-ads';
import { Ad, SiteSections } from '@xing-com/crate-ads-native-ads';
import type { SimilarJobData } from '@xing-com/crate-jobs-helpers';
import { GridItem } from '@xing-com/grid';

import { SimilarJob } from '../similar-job';

import { StyledGridContainer } from './grid-container';

type Props = { similarJobs: SimilarJobData[]; ads?: AdFields[] };

export const SimilarJobsGrid: FC<Props> = ({ similarJobs, ads = [] }) => {
  return (
    <StyledGridContainer variant="FullSize">
      {similarJobs.map((similarJob, i) => (
        // i is needed to ensure unique keys in the list because if not when changing
        // the size of the screen we duplicate items in version A
        // (because top jobs move to the bottom)
        <GridItem key={`${similarJob.job.id} + ${i}`} span={12} spanLarge={4}>
          <SimilarJob similarJob={similarJob} ijtParam="jb_20" />
        </GridItem>
      ))}

      {ads?.length > 0 ? (
        <GridItem span={12} spanLarge={4}>
          <Ad sectionId={SiteSections.JobsDetails} {...ads?.[0]} />
        </GridItem>
      ) : null}
    </StyledGridContainer>
  );
};
